import { createRoutes } from 'shared/hocs'

import { BeneficiariesOverview } from './overview'
import { BeneficiaryAdd } from './add'
import { BeneficiaryUpdate } from './update'
import { AddBeneficiaryBankAccount } from './addBankAccount'
import { MemberInvoicesOverview } from './overviewInvoices'
import { MemberInvoiceAdd } from './addMemberInvoice'

export const Beneficiaries = createRoutes(({ match }) => [
  {
    path: `${match.path}/add`,
    component: BeneficiaryAdd,
  },

  {
    path: `${match.path}/bank-account/:beneficiaryId`,
    component: AddBeneficiaryBankAccount,
  },

  {
    path: `${match.path}/edit/:beneficiaryId`,
    component: BeneficiaryUpdate,
  },

  {
    exact: true,
    path: `${match.path}/invoices/:memberId`,
    component: MemberInvoicesOverview,
  },
  {
    exact: true,
    path: `${match.path}/add-invoices/:memberId`,
    component: MemberInvoiceAdd,
  },
  {
    exact: true,
    path: match.path,
    component: BeneficiariesOverview,
  },
])
